module.exports = __webpack_public_path__ + "img/2_D.519d3e67.webp";